module.exports = __webpack_public_path__ + "img/news_5.20ad8421.png";